import { createBrowserRouter, type RouteObject } from "react-router";
import App from "./App";
import { Home } from "./pages/Home/Home";
import { About } from "./pages/About";
import { Services } from "./pages/Services/Services";
import { ServiceDetail } from "./pages/Services/ServiceDetail";
import { Sectors } from "./pages/Sectors";
import { Projects } from "./pages/Projects";
import { ProjectDetail } from "./pages/ProjectDetail";
import { Insights } from "./pages/Insights";
import { InsightDetail } from "./pages/InsightDetail";
import { Contact } from "./pages/Contact";
import { NotFound } from "./pages/NotFound";

export const routes: RouteObject[] = [
    {
        path: '/',
        element: <App />,
        children: [
            {
                index: true,
                element: <Home />,
            },
            {
                path: 'about',
                element: <About />,
            },
            {
                path: 'services',
                element: <Services />,
            },
            {
                path: 'services/:serviceId',
                element: <ServiceDetail />,
            },
            {
                path: 'sectors',
                element: <Sectors />,
            },
            {
                path: 'projects',
                element: <Projects />,
            },
            {
                path: 'projects/:id',
                element: <ProjectDetail />,
            },
            {
                path: 'insights',
                element: <Insights />,
            },
            {
                path: 'insights/:slug',
                element: <InsightDetail />,
            },
            // {
            //     path: 'downloads',
            //     element: <Downloads />,
            // },
            {
                path: 'contact',
                element: <Contact />,
            },
            {
                path: '*',
                element: <NotFound />,
            },
        ],
    },
];

export const router = createBrowserRouter(routes);
